import React from "react";
import { Modal } from "../../../../../components";

const AddTableModal = ({ isOpen, onClose }) => {
  return (
    <div>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title="Green Card Modal "
        width="max-w-7xl"
      >
        <div>AddTableModal</div>
      </Modal>
    </div>
  );
};

export default AddTableModal;
